import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import keycloakAuthUser from './keycloakAuth/reducer'

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  keycloakAuthUser
});

export default reducers;